export default __webpack_public_path__ + "static/media/btnred.63c953f7.svg";